import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=45fed5d5&scoped=true&"
import script from "./Sport.vue?vue&type=script&lang=js&"
export * from "./Sport.vue?vue&type=script&lang=js&"
import style0 from "./Sport.vue?vue&type=style&index=0&id=45fed5d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fed5d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VApp,VCard,VImg,VSheet,VSlideGroup,VSlideItem})
